module.exports = __webpack_public_path__ + "media/ai_video_cartoon.ae957503.mp4";